export default __webpack_public_path__ + "static/media/IMG_9230 copie.99fa1263.jpg";